import { LoadingOutlined } from "@ant-design/icons";
import React from "react";
import LinkOrSpan from "../links/LinkOrSpan/LinkOrSpan";
import styles from "./ActionsPopOverItem.module.scss";

interface ActionsPopOverItemProps {
  icon?: React.ReactNode;
  children: React.ReactNode;
  onClick?: () => void;
  to?: string;
  disabled?: boolean;
  danger?: boolean;
  black?: boolean;
  loading?: boolean;
}

const ActionsPopOverItem: React.FC<ActionsPopOverItemProps> = ({
  disabled,
  icon,
  to,
  danger = false,
  black = false,
  children,
  onClick,
  loading,
}) => (
  <LinkOrSpan
    className={[
      styles.PopOverItem,
      disabled ? styles.disabled : "",
      danger ? styles.danger : "",
      black ? styles.black : "",
    ].join(" ")}
    onClick={!disabled ? onClick : undefined}
    to={!disabled ? to : undefined}
  >
    {icon && <span className={styles.icon}>{loading ? <LoadingOutlined /> : icon}</span>}
    <span className={styles.text}>{children}</span>
    {!icon && loading && (
      <span className={styles.icon}>
        <LoadingOutlined />
      </span>
    )}
  </LinkOrSpan>
);

export default ActionsPopOverItem;
